/**
 * @module Experience/Shop/Cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const CART_SUPPORT_SERVICE = 'CartSupportService';
export const CART_SUPPORT_MODULE = 'CartSupportModule';

export const ADDRESS_SUPPORT_SERVICE = {
  ADDRESS_MODULE_NAME: 'CartSupport',
  ADDRESS_SUPPORT_SERVICE: 'AddressSupportService',
};

export const CART_ITEM_STATUS = {
  ITEM_ADD: 'ADD',
  ITEM_ADDED: 'ADDED',
  ITEM_REMOVE: 'REMOVE',
  ITEM_RETAIN: 'RETAIN',
};

export const AUDIT_CONTEXT = {
  AUDIT_SIM: 'SIM_NUMBER',
  AUDIT_IMEI: 'IMEI_NUMBER',
  AUDIT_SKU: 'SKU_NUMBER',
  AUDIT_PREF_LANG: 'PREF_LANG',
  LANGUAGE: 'customer-language-preference',
  IMEI: 'imei',
  SIM: 'sim',
  SKU: 'sku',
  EID: 'eid',
  OVERRIDE_PROFILE: 'overrideProfileStatus',
  IMEI2: 'imei2',
  SIM_NUM: 'simNumber',
  AUDIT_EID: 'EID',
  AUDIT_IMEI2: 'IMEI_NUMBER2',
  AUDIT_OVERRIDE: 'OVERRIDE_PROFILE_STATUS',
};

export const PAYMENT_ROUTES = {
  INSTORE: 'cart/payment/instore',
  DEFAULT: 'cart/payment',
};

export const TRANSACTION_TYPE = {
  PURCHASEEQUIPMENT: 'PURCHASEEQUIPMENT',
  ACTIVATION: 'ACTIVATION',
};

export const ACTIVATION_TYPE = {
  ESIM: 'ESIM',
  PSIM: 'PSIM',
};

export const ORDER_ACTION_TYPE = {
  ADD_SUBMIT: 'ADD_SUBMIT',
};

export const ORDER_SUBMIT_SUCCESS = [
  'Published',
  'INPROCESS',
  'COMPLETE',
  'BACKORDER',
  'OrderSubmitted',
];

export const ORDER_SUBMIT_ERROR_CODE = [
  'ORDER-0085',
  'ORDER-0084',
  'ORDER-0090',
  'ORDER-0088',
  'ORDER-0089',
];

export const PAYMENT_ERROR_CODE = ['ORDER-1177', 'ORDER-0091'];

export const PUBLISH_ERROR_CODE = 'ORDER-0082';

export const CHECKOUT_ERROR_CODE = 'OM-OC-E00347';

export const CONFIRMATION_ROUTE = {
  ORDER_CONFIRMATION: '/order-confirmation',
};

export const CART_ADDRESS_USAGE = {
  ADDRESS_USAGE_BILLING: 'BILLING',
  ADDRESS_USAGE_SHIPPING: 'SHIPPING',
  ADDRESS_USAGE_E911: 'E911',
  ADDRESS_USAGE_PPU: 'PPU',
  BILLING_ADDRESS: 'Billing address',
};
